import React, {useState, useEffect} from "react";
import { Toolbar, Alert, AlertTitle, AppBar, Slide, Stack, Backdrop, LinearProgress, Box, Button, Dialog, DialogActions, DialogTitle, FormControlLabel, Checkbox, Typography, Avatar, Badge, Container, Divider, IconButton, Grid, Card } from "@mui/material";

import ImageGallery from "react-image-gallery";
import LoadingModal from "./LoadingModal";
import ItemCardOpcao from "./ItemCardOpcao";
import numeral from "numeral";
import Config from "../config/config";

//actions
import v2_actionBuscarProduto from '../actions/v2/produtos/v2_actionBuscarProduto.js';
import { useDispatch, useSelector } from "react-redux";
import actionIsConfereEstoqueLoja from "../actions/config/actionIsConfereEstoqueLoja.js";
import v2_actionCoresProdutos from '../actions/v2/produtos/v2_actionCoresProdutos.js';
import v2_actionTamanhosProdutos from '../actions/v2/produtos/v2_actionTamanhosProdutos.js';
import v2_actionProdutosLojas from '../actions/v2/produtos/v2_actionProdutosLojas.js';
import v2_actionPrecosProdutos from '../actions/v2/produtos/v2_actionPrecosProdutos.js';

import { getDataUsuario } from '../services/auth.js';
import { formatarCodigoFilial } from "../utils/functions.js";
import { addToCart } from "../actions/index.js";
import Actions from "../constants/Actions.js";

const agruparPorGrade = (produtos) => {
  return produtos.reduce((acc, item) => {
    const { estoque, produto } = item;
    const { grade } = produto;
    
    if (!acc[grade]) {
      acc[grade] = { grade, estoque };
    } else {
      // Se já existe a grade, soma o estoque
      acc[grade].estoque += estoque;
    }
    return acc;
  }, {});
};

const transformarEmArray = (objetoAgrupado) => {
  return Object.values(objetoAgrupado);
};

const ItemHeaderStep = ({ title }) => {
  return (
    <Box sx={{ mt: 2, mb: 2, width: 300, p: 0.5, background: '#f9f9f9', borderRadius: 0.5 }}>
      <Typography sx={{ fontSize: 10, fontWeight: 'bold' }} color="#333">
        {title}
      </Typography>
    </Box>
  )
}

const ModalProduto = ({
  open,
  handleClickClose,
  produto,
  onLoadProduct
}) => {
    const dispatch = useDispatch();
    const [outrasCoresProduto, setOutrasCoresProduto] = useState([])
    const [outrosProdutos, setOutrosProdutos] = useState([])
    const [outrosTamanhos, setOutrosTamanhos] = React.useState([]);
    const [filiaisProdutos, setFiliaisProdutos] = React.useState([]);
    const [tamanhoProduto, SetTamanhoProduto] = React.useState('');
    const [corProduto, setCorProduto] = React.useState('');
    const [filialProduto, setFilialProduto] = React.useState('');
    const [parcelaSelecionada, setParcelaSelecionada] = React.useState('');
    const [modalTravaCarrinho, setModalTravaCarrinho] = React.useState(false);
    const [modalMudouPreco, setModalMudouPreco] = React.useState(false);
    const [loadingModal, setLoadingModal] = React.useState(false);
    const [isProdutoApto, setIsProdutoApto] = React.useState(false);
    const [produtoAbaixoEstoque, setprodutoAbaixoEstoque] = React.useState(false);
    const [precoProduto, setPrecoProduto] = React.useState('');
    const [isConfereEstoqueLoja, setIsConfereEstoqueLoja] = React.useState(false);
    const [isEstoque, setIsEstoque] = React.useState(false);
  
  
    const [loadingVerificaPreco, setLoadingVerificaPreco] = useState(false);
  
    //stare
    const products = useSelector(state => state.products);
    const cepOrigemProduto = useSelector(state => state.cepOrigemProduto);
    const cartItems = useSelector(state => state.cartItems);

    const verProduto = produto;
  
  
    const handleChangeParcelas = (event) => {
      setParcelaSelecionada(event.target.value);
    };
  
    const handleChangeIsProdutoApto = (event) => {
      setIsProdutoApto(event.target.checked);
    };
  
    const verificaProdutoButton = () => {
      if (isProdutoApto === false) {
        if (produtoAbaixoEstoque) {
          return false;
        } else {
          return true;
        }
      } else if (isProdutoApto === true) {
        if (produtoAbaixoEstoque) {
          return false;
        } else {
          return true;
        }
      }
    };

    function onCloseModal() {
      setCorProduto('');
      SetTamanhoProduto('');
      setFilialProduto('');
      setFiliaisProdutos([]);
      setOutrosTamanhos([]);
      handleClickClose();
    }
  
  
  
    const Teste = (product) => {
      let item = {
        product_image: product.images.length > 0 ? product.images[0]._id : null,
        product_id: product._id,
        variant_id: null,
        quantity: 1,
        discount_total: 0,
        name: product.name,
        regular_price: precoProduto,
        price: precoProduto,
        price_total: precoProduto,
        sku: product.sku,
        tax_class: 0,
        tax_total: 0,
        produto: product.produto,
        cor_produto: corProduto,
        grade: tamanhoProduto,
        variant_name: null,
        weight: product.weight,
        dimension: product.dimension,
        images: product.images,
        filial: formatarCodigoFilial(filialProduto),
        desc_cor_produto: product.desc_cor_produto,
        length: product.dimensions.length,
        heigth: product.dimensions.height,
        width: product.dimensions.width,
        use_descricao: product.use_descricao,
        use_referencia: product.use_referencia,
        use_cod_cor_produto: product.use_cod_cor_produto,
        use_descricao: product.use_cod_filial,
        use_cor_produto: product.use_cor_produto
      }
  
      if (cartItems.length === 0) {
        dispatch(addToCart(item));
        dispatch({ type: Actions.CEP_ORIGEM_PRODUTO, cepOrigemProduto: filialProduto });
        setCorProduto('');
        SetTamanhoProduto('');
        setFilialProduto('');
        setFiliaisProdutos([]);
        setOutrosTamanhos([]);
        setOutrasCoresProduto([]);
        onCloseModal();
        dispatch({ type: Actions.DRAWER_CARRINHO, drawerCarrinho: true })
  
      } else {
        if (filialProduto === cepOrigemProduto) {
          dispatch(addToCart(item));
          dispatch({ type: Actions.CEP_ORIGEM_PRODUTO, cepOrigemProduto: filialProduto });
          setCorProduto('');
          SetTamanhoProduto('');
          setFilialProduto('');
          setFiliaisProdutos([]);
          setOutrosTamanhos([]);
          setOutrasCoresProduto([]);
          onCloseModal();
          dispatch({ type: Actions.DRAWER_CARRINHO, drawerCarrinho: true })
        } else {
          setModalTravaCarrinho(true)
        }
      }
  
    }
  
  
  
  
    const handleEscolheuCor = async (cores, referencia, cor) => {
      setCorProduto(cor);
      setOutrosTamanhos([]);
      SetTamanhoProduto(null);
      setFilialProduto(null);
      setLoadingModal(true);
  
      let querys = `?referencia=${referencia}&cor_produto=${cor}`;
      const res = await v2_actionBuscarProduto(querys);
      if (res.status === 200 && res.data.produto) {
          onLoadProduct(res.data.produto);
      }
      
      const tamanhos = await v2_actionTamanhosProdutos(`?referencia=${referencia}&cor_produto=${cor}&loja=${getDataUsuario().filial}`);
      if (tamanhos.status === 200 && tamanhos.data.produtos.length > 0) {
        const agrupadosPorGrade = agruparPorGrade(tamanhos.data.produtos);
        const resultadoFinal = transformarEmArray(agrupadosPorGrade);
        console.log('agrupadosPorGrade', agrupadosPorGrade)
        setOutrosTamanhos(resultadoFinal);
        setIsEstoque(true);
      } else {
        setIsEstoque(false);
      }
      setLoadingModal(false);
  
  
    };
  
    const handleEscolheuFilial = async (data) => {
      setLoadingVerificaPreco(true)
      setprodutoAbaixoEstoque(false);
      if (data.estoque === 1) {
        setprodutoAbaixoEstoque(true);
      } else if (verProduto.grupo_produto === 'BOTA' || verProduto.linha === 'FEMININO') {
        setprodutoAbaixoEstoque(true);
      } else {
        setIsProdutoApto(true);
      }
  
  
      const filialEscolhida = data.loja;
  
      const precos = await v2_actionPrecosProdutos(`?referencia=${verProduto.use_referencia}&cor_produto=${verProduto.use_cod_cor_produto}&tamanho=${tamanhoProduto}&loja=${filialEscolhida}`);
  
      if(precos.status === 200 && precos.data.preco) {
        setPrecoProduto(precos.data.preco);
        setFilialProduto(filialEscolhida);
      }
      setLoadingVerificaPreco(false);
  
    };
  
    const handleEscolheuTamanho = async (data) => {
      setprodutoAbaixoEstoque(false);
      if (data.estoque === 1) {
        setprodutoAbaixoEstoque(true);
      } else {
        setIsProdutoApto(true);
      }
      setFilialProduto('');
      SetTamanhoProduto(data.grade);
      console.log('data', data)
      const produtosLojas = await v2_actionProdutosLojas(`?referencia=${verProduto.use_referencia}&cor_produto=${verProduto.use_cod_cor_produto}&tamanho=${data.grade}&loja_vendedor=${getDataUsuario().filial}`);
      if(produtosLojas.status === 200 && produtosLojas.data.produtos.length > 0) {
        setFiliaisProdutos(produtosLojas.data.produtos);
      }
  
  
    };
  

  
 
  
    ///modals
    const handleCloseModalTravaCart = () => {
      setModalTravaCarrinho(false);
    };
  
    const handleCloseModalMudouPreco = () => {
      setModalMudouPreco(false);
    };
  
    const selectedCorBorder = (data) => {
      if (corProduto) {
        if (corProduto === data.use_cod_cor_produto) {
          return '#ccc';
        }
      }
    };
  
    const selectedFilial = (data) => {
      console.log(filialProduto)
      if (filialProduto) {
        if (filialProduto === data.loja) {
          return '#2BC137 ';
        }
      }
    };
  
  
    const selectedTamanho = (data) => {
      console.log(tamanhoProduto)
      if (tamanhoProduto) {
        if (tamanhoProduto === data.grade) {
          return '#2BC137';
        }
      }
    };
  
    useEffect(() => {
      actionIsConfereEstoqueLoja().then(res => {
        setIsConfereEstoqueLoja(res.data.data);
      }).catch(err => console.log(err))
    }, []);

    // Adicionando novo useEffect para carregar cores
    useEffect(() => {
      setLoadingModal(true);
      setCorProduto(verProduto?.use_cod_cor_produto)
      const carregarCores = async () => {
        if (verProduto?.use_cod_cor_produto) {

          try {
            const cores = await v2_actionCoresProdutos(`?referencia=${verProduto.use_referencia}`);
            if (cores.status === 200) {
              setOutrasCoresProduto(cores.data.cores);
              if (!corProduto || corProduto === '') {
                handleEscolheuCor(cores.data.cores, verProduto.use_referencia, verProduto.use_cod_cor_produto);
              } else {
                setLoadingModal(false);
              }
            }
          } catch (error) {
            console.error('Erro ao carregar cores:', error);
          }
          setLoadingModal(false);
        }
      };
      
      carregarCores();
    }, [verProduto]);
  
    const DEFAULT_IMAGE = 'https://katuxa.sfo3.digitaloceanspaces.com/pdv/sem-imagem.jpg';

    const verificaEstoqueTamanho = (data) => {
        if (data.estoque === 0) {
          return (
            <Badge badgeContent="0" color="error">
              <Card
                style={{
                  padding: 10,
                  border: 2,
                  borderColor: '#ccc',
                  borderStyle: 'solid',
                  opacity: 0.5,
                  cursor: 'not-allowed'
                }} item md={1} lg={1}>
                <Typography variant="caption" color="text.secondary">{data?.grade}</Typography>
              </Card>
            </Badge>
          )
        } else if (data.estoque === 1) {
          return (
            <Badge badgeContent={data.estoque} color="warning">
              <Card
                onClick={() => { handleEscolheuTamanho(data) }}
                style={{
                  padding: 10,
                  border: 2,
                  borderColor: selectedTamanho(data),
                  borderStyle: 'solid',
                }} item md={1} lg={1}>
                <Typography variant="caption">{data?.grade}</Typography>
              </Card>
            </Badge>
          )
        } else {
          return (
            <Badge badgeContent={data.estoque} color="primary">
              <Card
                onClick={() => { handleEscolheuTamanho(data) }}
                style={{
                  padding: 10,
                  border: 2,
                  borderColor: selectedTamanho(data),
                  borderStyle: 'solid',
                }} item md={1} lg={1}>
                <Typography variant="caption">{data.grade === "UN" ? "UN" : data.grade}</Typography>
              </Card>
            </Badge>
          )
        }
      }
    
    
      const verificaEstoqueFilial = (data) => {
    
        if (data.estoque === 1) {
          return (
            <Badge badgeContent={data.estoque} color="error">
              <Card onClick={() => { handleEscolheuFilial(data) }} style={{
                padding: 10,
                fontWeight: 'bold',
                fontSize: 12,
                color: '#333',
                margin: 10,
                borderRadius: 10,
                border: 2,
                borderColor: selectedFilial(data),
                borderStyle: 'solid',
              }} item md={1} lg={1}>
                <div style={{ fontSize: 14 }}>LOJA {data.loja}</div>
              </Card>
    
            </Badge>
          )
        } else {
          return (
            <Badge badgeContent={data.estoque} color="primary">
              <Card onClick={() => { handleEscolheuFilial(data); console.log('teste') }} style={{
                padding: 10,
                fontWeight: 'bold',
                fontSize: 12,
                color: '#333',
                margin: 10,
                borderRadius: 10,
                border: 2,
                borderColor: selectedFilial(data),
                borderStyle: 'solid',
              }} item md={1} lg={1}>
                <div style={{ fontSize: 14 }}>LOJA {data.loja}</div>
              </Card>
    
            </Badge>
    
          )
    
        }
      }
    

    function getProductImages(verProduto, maxImages = 5) {
      if (!verProduto || !verProduto.images || verProduto.images.length === 0) {
        return [{ original: DEFAULT_IMAGE, thumbnail: DEFAULT_IMAGE }];
      }
    
      return Array.from({ length: maxImages }, (_, index) => {
        const imageUrl = verProduto.images.length > index
          ? `${Config.base_fotos}/fotos/${verProduto.produto}_${verProduto.cor_produto}_0${index + 1}.jpg`
          : DEFAULT_IMAGE;
        
        return { original: imageUrl, thumbnail: imageUrl };
      });
    }
    
    const imagensProduto = getProductImages(verProduto);
    

  return (
    <Dialog fullScreen open={open} className="dialog-ver-produto" onClose={onCloseModal}>
      <div>
        {loadingModal ? (
          <Stack alignContent="center" justifyContent="center" alignItems="center">
            <LoadingModal />
          </Stack>
        ) : (
          <>
            <Button style={{ background: "#f03", borderRadius: 0, color: "#fff" }} onClick={onCloseModal} fullWidth>
              Fechar
            </Button>
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
              <Grid container spacing={5}>
                <Grid item md={7} sm={12} xs={12}>
                  <Box>
                    <ImageGallery showPlayButton={false} items={imagensProduto} />
                  </Box>
                </Grid>
                <Grid item md={5} sm={12} xs={12} style={{ paddingTop: 10 }}>
                  <Box style={{ padding: 15 }}>
                    <Typography variant="h6" gutterBottom>
                      {verProduto?.use_descricao}
                    </Typography>
                    <Typography variant="caption" gutterBottom>
                      REFERENCIA: <strong>{verProduto?.use_referencia}</strong>
                    </Typography>
                    <Stack direction="row" spacing={3}>
                      <Typography variant="caption">CODIGO COR: <strong>{verProduto?.use_cod_cor_produto}</strong></Typography>
                      <Typography variant="caption">COR: <strong>{verProduto?.use_cor_produto}</strong></Typography>
                    </Stack>
                    <Divider sx={{ borderStyle: "dashed" }} />
                    <ItemHeaderStep title="Escolha a cor" />
                    <Grid container spacing={1} style={{ marginTop: 10 }}>
                      {outrasCoresProduto.map((cor, index) => (
                        <Grid key={index} item md={6}>
                          <ItemCardOpcao
                            selected={selectedCorBorder(cor)}
                            value={cor.use_cor_produto}
                            onClick={() => handleEscolheuCor(cor, verProduto.use_referencia, cor.use_cod_cor_produto)}
                          />
                        </Grid>
                      ))}
                    </Grid>
                    {corProduto ? (
                      isEstoque ? (
                        <div style={{ paddingTop: 20 }}>
                          <Divider sx={{ borderStyle: "dashed" }} />
                          <ItemHeaderStep title="Escolha o tamanho" />
                          <Grid container spacing={2} style={{ paddingBottom: 20, paddingTop: 20, overflowY: "auto" }}>
                            {outrosTamanhos.map((data) => (
                              <Box key={data} style={{ margin: 5 }}>{verificaEstoqueTamanho(data)}</Box>
                            ))}
                          </Grid>
                        </div>
                      ) : (
                        <Box style={{ marginTop: 20 }}>
                          <Alert severity="warning">
                            <AlertTitle>PRODUTO SEM ESTOQUE</AlertTitle>
                            Entre em contato com o suporte para mais informações
                          </Alert>
                        </Box>
                      )
                    ) : null}
                    {tamanhoProduto && (
                      <div style={{ marginTop: 5 }}>
                        <Divider style={{ marginBottom: 5 }} />
                        <ItemHeaderStep title="Escolha a filial" />
                        <Grid container spacing={2} style={{ overflowY: "auto", paddingTop: 15 }}>
                          {filiaisProdutos.map((data, index) => (
                            <Box key={index}>{verificaEstoqueFilial(data)}</Box>
                          ))}
                        </Grid>
                        {loadingVerificaPreco && <LinearProgress sx={{ mt: 2, mb: 1 }} />}
                      </div>
                    )}
                    {filialProduto && (
                      <>
                        {isConfereEstoqueLoja ? (
                          <>
                            <Stack sx={{ mb: 3, mt: 2 }}>
                              <Typography sx={{ fontSize: 10 }}>Preço à vista</Typography>
                              <Stack direction="row" alignItems="center" spacing={1}>
                                <Typography variant="caption">R$</Typography>
                                <Typography variant="h4"><strong>{numeral(precoProduto * 0.9).format("0,0.00")}</strong></Typography>
                              </Stack>
                            </Stack>
                            {produtoAbaixoEstoque && (
                              <FormControlLabel
                                control={<Checkbox checked={isProdutoApto} onChange={handleChangeIsProdutoApto} />}
                                label={`Concordo que verifiquei o produto na filial ${filialProduto} e está apto para ser vendido`}
                              />
                            )}
                            <Button fullWidth sx={{ color: "#fff", background: "#007F00", mt: 2 }} disabled={!isProdutoApto} onClick={() => Teste(verProduto)}>
                              Adicionar no Carrinho
                            </Button>
                          </>
                        ) : (
                          <Button fullWidth sx={{ color: "#fff", background: "#007F00", mt: 3 }} onClick={() => Teste(verProduto)}>
                            Adicionar no Carrinho
                          </Button>
                        )}
                      </>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </>
        )}

        <Dialog
          open={modalTravaCarrinho}
          onClose={handleCloseModalTravaCart}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">NÃO FECHAMOS VENDA COM PRODUTOS DE OUTRAS FILIAIS.</DialogTitle>
          <DialogActions>
            <Button onClick={handleCloseModalTravaCart} color="primary">
              Fechar
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={modalMudouPreco}
          onClose={handleCloseModalMudouPreco}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">ENCONTRAMOS OUTRO PREÇO PRA ESSA FILIAL!</DialogTitle>
          <DialogActions>
            <Button onClick={handleCloseModalMudouPreco} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </Dialog>
  );
};

export default ModalProduto;
